import React from "react";
import { PaymentType } from "univapay-node";

import { Content } from "../common/FormConfirm";

export const ContentKonbini = () => <Content paymentType={PaymentType.KONBINI} />;

export default ContentKonbini;
